export const getToken = () => {
    return localStorage.getItem('msal.idtoken')
}

export const setToken = (valor) => {
    localStorage.setItem('msal.idtoken', valor)
}

export const removeToken = (valor) => {
    localStorage.removeItem('msal.idtoken')
}